(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityBillingConfigDialogController', FacilityBillingConfigDialogController);

    FacilityBillingConfigDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FacilityBillingConfig', 'Facility'];

    function FacilityBillingConfigDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FacilityBillingConfig, Facility) {
        var vm = this;

        vm.facilityBillingConfig = entity;
        vm.clear = clear;
        vm.save = save;
        vm.facilities = Facility.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facilityBillingConfig.id !== null) {
                FacilityBillingConfig.update(vm.facilityBillingConfig, onSaveSuccess, onSaveError);
            } else {
                FacilityBillingConfig.save(vm.facilityBillingConfig, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:facilityBillingConfigUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
